import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';

/**
 * /post-job dispatcher.
 *   admin  → render the AdminDashboard (existing job creation flow)
 *   else   → redirect to /collaborate so the user can enrol an organisation first
 *            (because posting jobs requires being a verified collaborator).
 */
const PostJob = () => {
    const navigate = useNavigate();
    const role = localStorage.getItem('role');

    useEffect(() => {
        if (role && role !== 'admin') {
            navigate('/collaborate', { replace: true });
        }
    }, [role, navigate]);

    if (role === 'admin') return <AdminDashboard />;
    return null; // redirect in flight
};

export default PostJob;
